import { Color } from '../../app/models/color';

export class ColorPickerOptions {

    static hexColors = [
        '#000000',
        '#444444',
        '#888888',
        '#CCCCCC',
        '#FFFFFF',
        '#FE2712',
        '#FD4D0C',
        '#FC600A',
        '#FB8604',
        '#FB9902',
        '#FBA90A',
        '#FCBA12',
        '#FDDC22',
        '#FDED2A',
        '#FEFE33',
        '#E4F132',
        '#CBE432',
        '#B2D732',
        '#98CA32',
        '#7FBD32',
        '#66B032',
        '#559E54',
        '#448D76',
        '#347B98',
        '#236AB9',
        '#1258DC',
        '#183BF0',
        '#2E2FE3',
        '#4424D6',
        '#5A18C9',
        '#700CBC',
        '#8601AF',
        '#AE0D7A',
        '#C21460',
        '#D61A46',
        '#EA202C'];

    static noteColorsHex = [
        '#FFFFFF',
        '#FFF79B',
        '#FFB0CA',
        '#ACD8FF',
        '#C0ED72',
        '#E6E6E6'
    ];

    static noteColors = ColorPickerOptions.noteColorsHex.map(ele => {
        return Color.createColor(
            ColorPickerOptions.hexToR(ele),
            ColorPickerOptions.hexToG(ele),
            ColorPickerOptions.hexToB(ele), 0.9);
    });

    static colors = ColorPickerOptions.hexColors.map(ele => {
        return Color.createColor(
            ColorPickerOptions.hexToR(ele),
            ColorPickerOptions.hexToG(ele),
            ColorPickerOptions.hexToB(ele), 1);
    });

    /*static colors = [
        Color.createColor(0, 0, 255, 1),
        Color.createColor(0, 255, 0, 1),
        Color.createColor(255, 0, 0, 1),
        Color.createColor(186, 189, 194, 1),
        Color.createColor(240, 255, 0, 0.4),
        Color.createColor(0, 255, 240, 0.4),

        Color.createColor(0, 0, 255, 1),
        Color.createColor(0, 255, 0, 1),
        Color.createColor(255, 0, 0, 1),
        Color.createColor(186, 189, 194, 1),
        Color.createColor(240, 255, 0, 0.4),
        Color.createColor(0, 255, 240, 0.4),

        Color.createColor(0, 0, 255, 1),
        Color.createColor(0, 255, 0, 1),
        Color.createColor(255, 0, 0, 1),
        Color.createColor(186, 189, 194, 1),
        Color.createColor(240, 255, 0, 0.4),
        Color.createColor(0, 255, 240, 0.4),

        Color.createColor(0, 0, 255, 1),
        Color.createColor(0, 255, 0, 1),
        Color.createColor(255, 0, 0, 1),
        Color.createColor(186, 189, 194, 1),
        Color.createColor(240, 255, 0, 0.4),
        Color.createColor(0, 255, 240, 0.4),

        Color.createColor(0, 0, 255, 1),
        Color.createColor(0, 255, 0, 1),
        Color.createColor(255, 0, 0, 1),
        Color.createColor(186, 189, 194, 1),
        Color.createColor(240, 255, 0, 0.4),
        Color.createColor(0, 255, 240, 0.4),

        Color.createColor(0, 0, 255, 1),
        Color.createColor(0, 255, 0, 1),
        Color.createColor(255, 0, 0, 1),
        Color.createColor(186, 189, 194, 1),
        Color.createColor(240, 255, 0, 0.4),
        Color.createColor(0, 255, 240, 0.4),
    ];*/

    static hexToR(h): number {
        return parseInt((ColorPickerOptions.cutHex(h)).substring(0, 2), 16);
    }

    static hexToG(h): number {
        return parseInt((ColorPickerOptions.cutHex(h)).substring(2, 4), 16);
    }

    static hexToB(h): number {
        return parseInt((ColorPickerOptions.cutHex(h)).substring(4, 6), 16);
    }

    static cutHex(h): string {
        return (h.charAt(0) === '#') ? h.substring(1, 7) : h;
    }
}
